import { ApiCallWithErrorHandling, FilterValueDto } from "../../../Business/Common/CommonBusiness";
import { VoucherListApi } from "../../../Business/VoucherListBusiness";
import { GET_FILTER_VOUCHER_LIST, GET_VOUCHER_LIST, VoucherList, VoucherListGrid, VoucherListQuery, VoucherListQueryResultDto } from "../../../Model/VoucherList";
import { rootStore } from "../../Store/rootStore";
import { getAccessToken } from "../AuthenticationAction";

export const GetVoucherList = async (tableQuery : VoucherListQuery)=> {
 
    let api = new VoucherListApi();
    let data = await ApiCallWithErrorHandling(()=>api.GetGrid(tableQuery) ); 
    rootStore.dispatch({ type: GET_VOUCHER_LIST, payload: { VoucherListGridResult: data, filter: null } as VoucherListGrid });
}



export async function GetFilterColumnVoucherList(columName: string, columValue: string, queryFilter?: VoucherListQuery) {
    let result: FilterValueDto[] | undefined;
    let api = new VoucherListApi();

    if (queryFilter !== null && queryFilter !== undefined) {
        result = await ApiCallWithErrorHandling<Promise<FilterValueDto[]>>(() => api.VoucherListGetFilterResult(columName, columValue,queryFilter ));
    } else {
        result = await ApiCallWithErrorHandling<Promise<FilterValueDto[]>>(() => api.VoucherListGetFilterResult(columName, columValue));
    }
    let rtn = { filter: result, VoucherListGridResult: null } as VoucherListGrid;
    rootStore.dispatch({ type: GET_FILTER_VOUCHER_LIST, payload: rtn });
}